import React from "react"
// import { css } from "@emotion/core"
import { graphql } from "gatsby"
// import { rhythm } from "../../utils/typography"
import Layout from "./layout-3"


import Collapse from '@material-ui/core/Collapse'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'



const IndexPage = ({ data }) => {





  return (

    <Layout>
      <div class="iframe-container">
        <iframe src="
        https://docs.google.com/document/d/10Sp6_0zZoo7L2J5sC-JngQYwH5ULAz9hFaZcihpDzoU/edit?usp=sharing&rm=minimal"></iframe>     
      </div>
    </Layout>
  )
}

export default IndexPage




export const query = graphql`
  query {
    allMarkdownRemark(
        sort: { fields: [frontmatter___date], order: ASC } 
        filter: {fileAbsolutePath: {regex: "/t3f19/_project/.*.md$/"}}
        ) {
      totalCount
      edges {
        node {
          html
          id
          frontmatter {
            title
            date
          }
          fields {
            slug
          }
        }
      }
    }
  }
`